import src from "IMAGE";
export default { src, width: 435, height: 92, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAIAAADq9gq6AAAAPUlEQVR42gEyAM3/AAwoaTBHfldplUBViDNJgDJJfyU9dwwnaAAMKGgRLGsWMG4zSoAuRX0PKmoNKGkLJ2hc+Q0v/wyitQAAAABJRU5ErkJggg=="};
